// eslint-disable-next-line unused-imports/no-unused-vars
export const appPublicationGQLFields = (fields) => {
    return `
    id
    addedById
    itemId
    networkId
    createdAt
  `;
};
//# sourceMappingURL=appPublication.fields.js.map